var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.992,
    height: 28.92,
    viewBox: "0 0 26.992 28.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_004-list",
    "data-name": "004-list",
    transform: "translate(-11.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    transform: "translate(21.385 13.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_388",
    "data-name": "Caminho 388",
    d: "M145.665,161.8H130.292a.842.842,0,0,0,0,1.684h15.373a.842.842,0,0,0,0-1.684Z",
    transform: "translate(-129.45 -161.8)",
    fill: "#19a4bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    "data-name": "Grupo 91",
    transform: "translate(11.45 10.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    "data-name": "Grupo 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_389",
    "data-name": "Caminho 389",
    d: "M15.365,125.3a3.915,3.915,0,1,0,3.915,3.915A3.913,3.913,0,0,0,15.365,125.3Zm0,6.146a2.231,2.231,0,1,1,2.231-2.231A2.23,2.23,0,0,1,15.365,131.446Z",
    transform: "translate(-11.45 -125.3)",
    fill: "#19a4bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93",
    transform: "translate(21.385 3.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    "data-name": "Grupo 92",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_390",
    "data-name": "Caminho 390",
    d: "M145.665,36.8H130.292a.842.842,0,0,0,0,1.684h15.373a.842.842,0,0,0,0-1.684Z",
    transform: "translate(-129.45 -36.8)",
    fill: "#19a4bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95",
    transform: "translate(11.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_391",
    "data-name": "Caminho 391",
    d: "M15.365,0A3.915,3.915,0,1,0,19.28,3.915,3.913,3.913,0,0,0,15.365,0Zm0,6.154A2.231,2.231,0,1,1,17.6,3.923,2.23,2.23,0,0,1,15.365,6.154Z",
    transform: "translate(-11.45)",
    fill: "#19a4bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97",
    transform: "translate(21.385 24.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_392",
    "data-name": "Caminho 392",
    d: "M145.665,286.8H130.292a.842.842,0,1,0,0,1.684h15.373a.842.842,0,0,0,0-1.684Z",
    transform: "translate(-129.45 -286.8)",
    fill: "#19a4bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    transform: "translate(11.45 21.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_393",
    "data-name": "Caminho 393",
    d: "M15.365,250.5a3.915,3.915,0,1,0,3.915,3.915A3.913,3.913,0,0,0,15.365,250.5Zm0,6.154a2.231,2.231,0,1,1,2.231-2.231A2.23,2.23,0,0,1,15.365,256.654Z",
    transform: "translate(-11.45 -250.5)",
    fill: "#19a4bb"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.3b4b83b9c88d9e425de503c5a31d7860.svg";
export { ForwardRef as ReactComponent };